<!-- Delete Confirm -->
<ng-template #message_draw_tool_template>
  <div [innerHTML]="'notification.free_form_draw_tool_message' | translate"></div>
</ng-template>

<!-- Content -->
<div #imageElement
  class="w-full h-full">
  <!-- Spinner -->
  @if (showSpinner()) {
    <div
      class="flex justify-content-center align-items-center w-full h-full absolute">
      <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
    </div>
  }
</div>
